import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/transitional/components/View';
import { Button } from 'foundations-components/transitional/components/Button';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { BaseContentControlWrapper } from '../../../components/ContentControlWrapper.migrated';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PracticalExerciseLoading = () => {
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(View, {
      backgroundColor: "fill-surface-default",
      blockSize: "100%",
      inlineSize: "100%",
      children: /*#__PURE__*/_jsx(LoadingSpinner, {
        grow: true,
        minHeight: 300
      })
    }), /*#__PURE__*/_jsx(BaseContentControlWrapper, {
      children: /*#__PURE__*/_jsx(Button, {
        disabled: true,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.practicalExercise.startExercise"
        })
      })
    })]
  });
};
export default PracticalExerciseLoading;